import '.cc{position:relative;}.ssr-plugin'
import '.hz{width:64px;}.ssr-plugin'
import '.i0{height:64px;}.ssr-plugin'
import '.bo{flex-shrink:0;}.ssr-plugin'
import '.l{position:absolute;}.ssr-plugin'
import '.i1{bottom:-4px;}.ssr-plugin'
import '.dd{right:-4px;}.ssr-plugin'
import '.eq{border-radius:50%;}.ssr-plugin'
import '.i2{border:2px solid var(--shades-white);}.ssr-plugin'
import '.p{overflow:hidden;}.ssr-plugin'
import '.i3{width:32px;}.ssr-plugin'
import '.i4{height:32px;}.ssr-plugin'
import { styled } from 'inlines'
import { Avatar } from '@app/components/core/avatar/Avatar'
import { Image } from '@app/components/core/image/Image'

type ConversationAvatarProps = {
  initiativeImage?: string
  userAvatar?: string
  userName: string
}

export const ConversationAvatar = ({
  initiativeImage,
  userAvatar,
  userName,
}: ConversationAvatarProps) => {
  return (
    <div className="cc hz i0 bo"
    >
      {initiativeImage ? (
        <Image
          src={initiativeImage}
          resizeWidth={128}
          alt="initiative"
          style={{
            width: '100%',
            height: '100%',
            objectFit: 'cover',
            borderRadius: '12px',
          }}
        />
      ) : (
        <Avatar
          size="medium"
          shape="square"
          labelSource={userName}
          variant="yellow"
        />
      )}
      <div className="l i1 dd eq i2 p i3 i4"
      >
        <Avatar
          size="extra-small"
          shape="circle"
          image={userAvatar}
          labelSource={userName}
        />
      </div>
    </div>
  )
}
